import React from 'react';
import SupportArticleSectionTypes from './index';

function SupportArticleReusableBlock({ section }) {
  return (
    <>
      {section.blockReference?.blocks?.map(section => {
        if (SupportArticleSectionTypes.hasOwnProperty(section._type)) {
          return React.createElement(
            SupportArticleSectionTypes[section._type],
            { section: section, key: section._key }
          );
        }
      })}
    </>
  );
}

export default SupportArticleReusableBlock;
